// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"b07e40d2","236":"c721176d","605":"2f841096"}[chunkId] + ".chunk.js";
};